import styled from 'styled-components';
import { fontSize, path, radius, size } from '@/public/template/common/css/setting/variable';
import { ExpertCheckMarkIcon } from '@/public/template/common/expert/icon/ExpertCheckMarkIcon';
import { FirstReactedExpert } from '@/public/template/common/store/article/articleExpertReaction/types';

const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  padding: 4px 8px;
  margin: 8px 8px 18px;
  background-color: ${props => props.theme.news.palette.bg_lv2_common};
  border-radius: ${radius.middle_common};
`;
const Text = styled.span`
  display: flex;
  align-items: center;
  margin-left: 2px;
  font-size: ${fontSize.px12};
  font-weight: bold;
  color: ${props => props.theme.news.palette.text_base_common};
`;

const Link = styled.a`
  display: inline-flex;
  align-items: center;
  font-size: ${fontSize.px13};
  line-height: 1;
  color: ${props => props.theme.news.palette.link_pc};
  &:hover {
    color: ${props => props.theme.news.palette.link_hover_pc};
  }
`;

const ProfileIcon = styled.img`
  width: ${size.comment_circle_icon_pc};
  height: ${size.comment_circle_icon_pc};
  margin: 0 2px;
  border: 2px solid #aacdff;
  border-radius: 50%;
`;

export const ExpertRecommendTopLabel: React.FC<{ count: number; firstReactedExpert: FirstReactedExpert }> = ({
  count,
  firstReactedExpert
}) => {
  if (count < 1) {
    return null;
  }
  return (
    <TopWrapper>
      <ExpertCheckMarkIcon size={20} />
      <Text>
        <Link
          href={firstReactedExpert.expertProfileUrl}
          data-cl-params="_cl_vmodule:expertpick_info;_cl_link:prof;_cl_position:0;"
        >
          <ProfileIcon src={firstReactedExpert.expertImageUrl} />
          {firstReactedExpert.expertName}
        </Link>
        {count === 1 ? 'さんが推薦中' : `さんなど${count}名の専門家が推薦中`}
      </Text>
    </TopWrapper>
  );
};

const TimelineWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
const TimelineText = styled.span`
  position: relative;
  display: inline-block;
  padding-left: 16px;
  font-size: ${fontSize.px10};
  font-weight: bold;
  line-height: 16px;
  color: ${props => props.theme.news.palette.expert_label_text};
  white-space: nowrap;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    content: '';
    background-image: url(${path.img_icon_expert_verified});
    background-repeat: no-repeat;
    background-size: contain;
  }
`;
export const ExpertRecommendTimelineLabel: React.FC = () => {
  return (
    <TimelineWrapper>
      <TimelineText>専門家が推薦中</TimelineText>
    </TimelineWrapper>
  );
};
